import { FC } from 'react';

export interface ButtonProps {
    type?: 'button' | 'submit';
    size?: 'small' | 'medium' | 'large';
    disabled?: boolean;
    extendedClassName?: string;
    onClick?: () => void;
    btnText: string;
    testId: string;
    icon?: React.ReactNode;
    title?: string;
}

const Button: FC<ButtonProps> = (props) => {
    const { size = 'small', type = 'button' } = props;

    const baseClassName =
        'btn text-center text-[#212529] px-[12px] py-[8px] font-normal border border-solid border-[#adadad]';
    const defaultClassName =
        'bg-gradient-to-b from-[#FFFFFF] to-[#f0f0f0] rounded-[0.25rem] shadow-sm hover:bg-gradient-to-b hover:from-[#FFFFFF] hover:to-[#ddd] active:bg-gradient-to-b focus:shadow-[0_0_0_0.25rem_rgba(13,110,253,0.25)]';
    const disabledClassName = props.disabled ? 'btn-disabled text-gray-500' : '';

    let sizeClassName = 'btn-sm';
    if (size === 'medium') {
        sizeClassName = 'btn-md';
    } else if (size === 'large') {
        sizeClassName = 'btn-lg';
    }

    const buttonClassNames = [
        baseClassName,
        sizeClassName,
        props.disabled ? disabledClassName : defaultClassName,
        props.extendedClassName,
    ];

    return (
        <button
            type={type}
            className={buttonClassNames.join(' ')}
            data-test-id={props.testId}
            onClick={props.onClick}
            disabled={props.disabled}
            title={props.title}
        >
            {props.icon && <>{props.icon}</>}
            {props.btnText}
        </button>
    );
};

export default Button;
